import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchCustomerComponent } from './search-customer.component';
import { ChooseCustomerComponent } from './choose-customer/choose-customer.component';

const routes: Routes = [
  {
    path:'',
    redirectTo: 'search',
    pathMatch: 'full',
  },
  {
    path:'search',
    component: SearchCustomerComponent,
  },
  {
    path:'list',
    component: ChooseCustomerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchCustomerRoutingModule { }
